module.exports = "/public/images/0db6284fc97c25fe9b4fd8368e9a7683.png";